import { render, staticRenderFns } from "./serviceHallLayout.vue?vue&type=template&id=7ee51bca&scoped=true&"
import script from "./serviceHallLayout.vue?vue&type=script&lang=js&"
export * from "./serviceHallLayout.vue?vue&type=script&lang=js&"
import style0 from "./serviceHallLayout.vue?vue&type=style&index=0&id=7ee51bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee51bca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppFooter: require('/usr/src/app/components/layout/Footer.vue').default})
